/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link, useNavigate } from "react-router-dom";

import Image from "../../assets/img/team/team-1-1.jpg";

const SingleTeam = (props) => {
  const navigate = useNavigate();
  const { itemClass, teamImage, titleClass, authorName, specialist, eduTagLine, doctorId } = props;
  const profilePath = doctorId ? `/doctor/${doctorId}` : "/team-details";
  return (
    <div className={itemClass ? itemClass : "it-team-item"}>
      <div className="it-team-thumb">
        <img src={teamImage ? teamImage : Image} alt="" />
      </div>
      <div className="it-team-content text-center">
        <div className="it-team-author-box">
          <h4 className="it-team-title" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            <Link className={titleClass ? titleClass : "hover-anim"} to={profilePath} title={authorName}>
              {authorName ? authorName : "Dr. Keely Evans"}
            </Link>
          </h4>
          <span style={{ display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {specialist ? specialist : "Cardiologist"}
          </span>
          {eduTagLine && (
            <p
              style={{
                fontSize: "12px",
                color: "#74747c",
                margin: "4px 0 0",
                lineHeight: "1.4",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              title={eduTagLine}
            >
              {eduTagLine}
            </p>
          )}
        </div>
        <div className="it-team-btn-group">
          <button
            className="ma-btn-secondary"
            style={{ borderRadius: 8, fontSize: ".875rem", padding: "10px 20px", cursor: "pointer" }}
            onClick={() => navigate(profilePath)}
          >
            View Profile
          </button>
          <button
            className="ma-btn-primary"
            style={{ borderRadius: 8, fontSize: ".875rem", padding: "10px 20px", cursor: "pointer" }}
            onClick={() => navigate(`${doctorId ? `/appointment` : "/appointment"}`)}
          >
            Consult Now
          </button>
          {/* <Link to={profilePath} className="it-team-btn it-team-btn--profile">
            View Profile
          </Link>
          <Link to={doctorId ? `/appointment` : "/appointment"} className="it-team-btn it-team-btn--book">
            Consult Now
          </Link> */}
        </div>
      </div>
    </div>
  );
};

export default SingleTeam;
